module.exports = __webpack_public_path__ + "media/wmsproduct.e18fefd7.mp4";